import * as React from 'react';
import Toast from '@src/components/toast';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const DOWNLOAD_UNAVAILABLE_MESSAGE = '当前客户端暂未开放，请稍后再试';

const normalizeDownloadUrl = value => {
  const url = typeof value === 'string' ? value.trim() : '';
  if (!url || /^(?:[a-z][a-z0-9+.-]*:|\/)/i.test(url)) return url;
  return /^([^/?#]+\.)+[^/?#]+(?:[/?#]|$)/.test(url) ? `https://${url}` : url;
};

const HarmonyDownloadModal = ({ visible, downloadUrl, onClose }) => {
  const downloadRef = React.useRef(null);
  const finalDownloadUrl = normalizeDownloadUrl(downloadUrl);

  React.useEffect(
    () => {
      if (!visible) return undefined;

      const previousActiveElement = document.activeElement;
      const handleKeyDown = event => {
        if (event.key === 'Escape') onClose();
      };

      document.addEventListener('keydown', handleKeyDown);
      if (downloadRef.current) downloadRef.current.focus();

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
        if (previousActiveElement && previousActiveElement.focus) previousActiveElement.focus();
      };
    },
    [visible, onClose]
  );

  if (!visible) return null;

  return (
    <div
      className={styles.overlay}
      role="presentation"
      onMouseDown={event => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className={styles.modal} role="dialog" aria-labelledby="harmony-download-title" aria-describedby="harmony-download-description">
        <h2 id="harmony-download-title" className={styles.visuallyHidden}>
          温馨提示
        </h2>
        <p id="harmony-download-description" className={styles.visuallyHidden}>
          鸿蒙端玩家请使用金山通行证登录，方可以进入官方服。官方服务器请认准四个字命名的服务器。
        </p>
        <img className={styles.title} src={require('./images/title.png')} alt="" aria-hidden="true" />
        <img className={styles.message} src={require('./images/message.png')} alt="" aria-hidden="true" />
        <button className={styles.closeButton} type="button" aria-label="关闭鸿蒙客户端下载提示" onClick={onClose}>
          <img src={require('./images/close.png')} alt="" />
        </button>
        <a
          className={styles.downloadButton}
          href={finalDownloadUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="下载鸿蒙客户端"
          ref={downloadRef}
          onClick={event => {
            if (!finalDownloadUrl) {
              event.preventDefault();
              Toast.info(DOWNLOAD_UNAVAILABLE_MESSAGE);
              return;
            }
            $$tracker.clickHongmengDown('弹框');
          }}
        >
          <img src={require('./images/download.png')} alt="" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
};

export default HarmonyDownloadModal;
